import { render, staticRenderFns } from "./personInChargeModal.vue?vue&type=template&id=4bd75856&scoped=true"
import script from "./personInChargeModal.vue?vue&type=script&lang=js"
export * from "./personInChargeModal.vue?vue&type=script&lang=js"
import style0 from "./personInChargeModal.vue?vue&type=style&index=0&id=4bd75856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd75856",
  null
  
)

export default component.exports